import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { track, getSessionId } from '../lib/tracker';

const SESSION_STARTED = 'byanfal_session_started';

export default function Tracker() {
    const location = useLocation();
    const lastPath = useRef(null);

    useEffect(() => {
        // Never track admin sessions in public visitor analytics
        if (window.location.pathname.startsWith('/admin')) return;
        // Fire session_start once per browser session
        getSessionId();
        if (!sessionStorage.getItem(SESSION_STARTED)) {
            sessionStorage.setItem(SESSION_STARTED, '1');
            track('session_start', { path: window.location.pathname, referrer: document.referrer || '' });
        }
    }, []);

    useEffect(() => {
        // Skip admin routes from public analytics
        if (location.pathname.startsWith('/admin')) return;
        if (lastPath.current === location.pathname) return;
        lastPath.current = location.pathname;
        track('page_view', { path: location.pathname, referrer: document.referrer || '' });
    }, [location.pathname]);

    return null;
}
